import React, { ReactNode } from 'react'
import FeatureStoreNavbar from './AppStoreNavbar'
import { useLocale } from 'src/lib/hooks/useLocal'

interface AppStoreLayoutProps {
  children: ReactNode
  hideHeader?: boolean
}

const AppStoreLayout = ({ children, hideHeader = false }: AppStoreLayoutProps) => {
  const { t } = useLocale()

  return (
    <div className='w-full p-8'>
      {!hideHeader && (
        <>
          <div className='mb-8 flex flex-col gap-1'>
            <h1 className='w-full text-xl font-semibold text-carbon'>{t('shopflo_app_store')}</h1>
            <p className='text-sm font-normal'>{t('feature_store_page_subheader')}</p>
          </div>

          <div className='mt-8'>
            <FeatureStoreNavbar />
          </div>
        </>
      )}

      <div className={hideHeader ? '' : 'mt-8'}>{children}</div>
    </div>
  )
}

export default AppStoreLayout
